/* template */
<template><div class="container"><mpx-view @tap="scanDualDesc" class="make-order-header">双通道抢票<mpx-image mode="aspectFit" src="https://ut-static.udache.com/webx/sfc/XNKxsIYqRbUxR384Y6Kfa_clipboard_image_1697628299313.png" class="icon" v-if="(pageFrom === 1)"/></mpx-view><div class="wrapper"><div v-for="(item, index) in (list)" :key="item.index" class="item"><mpx-image mode="aspectFit" :src="(item.icon)" class="icon"></mpx-image><div class="info"><div class="name">{{ item.name }}</div><div class="tip">{{ item.tip }}</div></div><div class="status"><mpx-view @tap="toOpen" class="off" v-if="(item.status === 1)">去开启</mpx-view><div class="on" v-if="(item.status === 2)"><es-icon size="12" name="check-circle" class="on-icon"></es-icon>已开启<mpx-view @tap="showDetail" class="detail-btn" v-if="(item.detail)">详情<es-icon size="12" name="angle-right" class="on-icon"></es-icon></mpx-view></div></div></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m2e7ba292"}'>
  .container
    width 100%
    height auto
    border-radius 10px
    background-color #FFFFFF
    line-height 1
    letter-spacing 0
    font-weight normal
    .make-order-header
      height 16px
      padding 16px 14px 0
      display flex
      align-items center
      font-family PingFangSC-Semibold
      font-size 16px
      color #333333
      .icon
        margin-left 3px
        width 16px
        height 16px
    .wrapper
      width 100%
      height auto
      box-sizing border-box
      padding 4px 16px 4px 14px
      background-color #FFFFFF
      border-radius 10px
      .item
        display flex
        align-items center
        height 62px
        position relative
        &:first-child
          &::after
            content ''
            position absolute
            bottom 0
            right 0
            width calc(100% - 42px)
            height 1px
            background-color #f2f6f9
        &:last-child
          &::after
            display none
        .icon, .status
          flex none
        .icon
          width 36px
          height 36px
          margin-right 10px
        .info
          flex 1
          .name
            font-family PingFangSC-Medium
            font-size 14px
            color #333333
          .tip
            font-family PingFangSC-Regular
            font-size 12px
            color #999999
            margin-top 5px
        .status
          .off
            width 54px
            height 24px
            border-radius 5px
            background #FF5900
            display flex
            align-items center
            justify-content center
            font-family PingFangSC-Medium
            font-size 12px
            color #FFFFFF
          .on
            display flex
            align-items center
            font-family PingFangSC-Medium
            font-size 12px
            color #00A442
            &-icon
              margin-right 3px
            .detail-btn
              color #666
              margin-left 12px
              @extend .flex-center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2e7ba292"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex2e7ba292%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex2e7ba292%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2e7ba292"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index2e7ba292/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
